import ListPractices from '@/pages/Practices/ListPractices.vue';
import ShowPractice from '@/pages/Practices/ShowPractice.vue';
import ShowPracticeActions from '@/pages/Practices/Practice/ShowActions.vue';
import ShowPracticeContent from '@/pages/Practices/Practice/ShowContent.vue';
import ShowPracticeContext from '@/pages/Practices/Practice/ShowContext.vue';
import ShowPracticeExperiments from '@/pages/Practices/Practice/ShowExperiments.vue';
import ShowPracticeOverview from '@/pages/Practices/Practice/ShowOverview.vue';
import ShowPracticeRating from '@/pages/Practices/Practice/ShowRating.vue';
import context from '@/router/guards/context';
export default [
    {
        path: 'practices',
        name: 'practices',
        redirect: { name: 'practices.list' },
        beforeEnter: [context],
    },
    {
        path: 'practices/list',
        name: 'practices.list',
        component: ListPractices,
        beforeEnter: [context],
    },
    {
        path: 'practices/:id',
        name: 'practices.show',
        component: ShowPractice,
        redirect: { name: 'practices.show.overview' },
        beforeEnter: [context],
        props: true,
        children: [
            {
                path: 'overview',
                name: 'practices.show.overview',
                component: ShowPracticeOverview,
            },
            {
                path: 'content',
                name: 'practices.show.content',
                component: ShowPracticeContent,
            },
            {
                path: 'context',
                name: 'practices.show.context',
                component: ShowPracticeContext,
            },
            {
                path: 'actions',
                name: 'practices.show.actions',
                component: ShowPracticeActions,
            },
            {
                path: 'rating',
                name: 'practices.show.rating',
                component: ShowPracticeRating,
            },
            {
                path: 'experiments',
                name: 'practices.show.experiments',
                component: ShowPracticeExperiments,
            },
        ]
    },
];
